import { Grid, GridColumn, Spinner } from '@teliaee/design-system';
import React from 'react';

const PaddedSpinner = (props: { minHeightPx?: number }) => (
  <Grid style={{ minHeight: props.minHeightPx ? `${props.minHeightPx}px` : '400px', marginRight: 0 }} align={['center-xs']} className="text-center">
    <GridColumn align={['middle-xs']}>
      <Spinner />
    </GridColumn>
  </Grid>
);

export default PaddedSpinner;
